import React from 'react';
import { Container } from '../common/Container';

const steps = [
  ['01', 'Authorization starts the file', 'Client, property, and county data come together.'],
  ['02', 'The appeal stays on track', 'Stage, deadlines, documents, and ownership stay current.'],
  ['03', 'The decision closes the loop', 'Update the client and move the file to invoice.'],
];

export const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="bg-brand-blue-50 py-24">
      <Container>
        <div className="grid gap-10 lg:grid-cols-[0.75fr_1.25fr]">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wider text-brand-red">How it works</p>
            <h2 className="mt-4 text-4xl font-bold tracking-tight text-brand-blue">From authorization to invoice.</h2>
          </div>
          <div className="border-t border-brand-blue-200">
            {steps.map(([number, title, description]) => (
              <div key={number} className="grid gap-4 border-b border-brand-blue-200 py-7 sm:grid-cols-[48px_0.75fr_1.25fr] sm:items-start">
                <span className="font-mono text-sm font-bold text-brand-red">{number}</span>
                <h3 className="text-xl font-bold text-brand-blue">{title}</h3>
                <p className="text-brand-white-700">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};
